/**
 * ff-gallery.js
 *
 * Thumbnail-to-main-image swapping and keyboard navigation for the
 * ff-product-hero media gallery. Kept separate from ff-product-purchase.js:
 * this only concerns *manual* browsing of a variant's media; variant-driven
 * image swaps are handled by the purchase script.
 */
(function () {
  'use strict';

  function qs(root, sel) {
    return root.querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function FFGallery(root) {
    this.root = root;
    this.mainImage = qs(root, '[data-ff-main-media] img');
    this.thumbs = qsa(root, '[data-ff-thumb]');
    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.thumbs.forEach(
      function (thumb, index) {
        thumb.addEventListener('click', this.onClick);
        thumb.addEventListener('keydown', this.onKeydown);
        thumb.dataset.ffThumbIndex = index;
      }.bind(this)
    );
  }

  FFGallery.prototype.destroy = function () {
    this.thumbs.forEach(
      function (thumb) {
        thumb.removeEventListener('click', this.onClick);
        thumb.removeEventListener('keydown', this.onKeydown);
      }.bind(this)
    );
  };

  FFGallery.prototype.select = function (thumb) {
    if (!thumb || !this.mainImage) return;
    var fullSrc = thumb.dataset.fullSrc;
    if (fullSrc) {
      this.mainImage.src = fullSrc;
      this.mainImage.removeAttribute('srcset');
    }
    var alt = thumb.dataset.fullAlt;
    if (alt) this.mainImage.alt = alt;
    this.thumbs.forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  };

  FFGallery.prototype.onClick = function (evt) {
    this.select(evt.currentTarget);
  };

  FFGallery.prototype.onKeydown = function (evt) {
    var index = parseInt(evt.currentTarget.dataset.ffThumbIndex, 10);
    var next = null;
    if (evt.key === 'ArrowRight') next = this.thumbs[index + 1];
    if (evt.key === 'ArrowLeft') next = this.thumbs[index - 1];
    if (next) {
      evt.preventDefault();
      next.focus();
      this.select(next);
    }
  };

  function initAll() {
    qsa(document, '[data-ff-product-hero]').forEach(function (root) {
      if (root.__ffGallery) return;
      root.__ffGallery = new FFGallery(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    qsa(evt.target, '[data-ff-product-hero]').forEach(function (root) {
      root.__ffGallery = null;
      root.__ffGallery = new FFGallery(root);
    });
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    qsa(evt.target, '[data-ff-product-hero]').forEach(function (root) {
      if (root.__ffGallery) {
        root.__ffGallery.destroy();
        root.__ffGallery = null;
      }
    });
  });

  // Theme Editor: bring the corresponding thumbnail into view when a media
  // block is selected, so merchants can see what they're editing.
  document.addEventListener('shopify:block:select', function (evt) {
    var block = evt.target;
    if (!block || !block.hasAttribute('data-ff-thumb')) return;
    var gallery = block.closest('[data-ff-product-hero]');
    if (gallery && gallery.__ffGallery) gallery.__ffGallery.select(block);
  });
})();
